import React from 'react';
import Styled from "styled-components";
import { fontQuicksand } from '../mixin';
import { device } from '../../../utils/responsive_utilities';

const CustomContainerA = ({
	settings
}) => {
	const { trialAvailable, trailDays } = settings;
	
	const getTrialEndDate = () => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let curr_date = new Date();
    let timeStampOfTrialEnd = curr_date.setDate(curr_date.getDate() + trailDays || 7);
    let trialEndDate = new Date(timeStampOfTrialEnd);
    return `${months[trialEndDate.getMonth()]} ${trialEndDate.getDate()}, ${trialEndDate.getFullYear()}`
  }

	if (trialAvailable) {
		return <TrialDate>You will not be charged until your FREE trial ends on {getTrialEndDate()}</TrialDate>
	}
	return null;
}

export const TrialDate = Styled.p`
  ${fontQuicksand(1.4, 1.8)}
  margin: 1rem 0;
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.1, 1.5)}
  }
  @media ${device.Phone} {
    ${fontQuicksand(1.1, 1.5)}
  }
`;

export default CustomContainerA;
